import React from 'react';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import {useDomainMonitorResume} from 'features/domain/model/useDomainMonitorMutations';
import ConfirmModal from 'shared/ui/Modal/ConfirmModal/ConfirmModal';
import {ExceededModal} from 'entities/user';
import IDomainMonitorOutput from 'features/domain/model/DomainMonitor/IDomainMonitor';

interface IDomainMonitorResumeModalProps {
    item: IDomainMonitorOutput,
    open: boolean;
    handleClose: () => void;
}

const DomainMonitorResumeModal: React.FC<IDomainMonitorResumeModalProps> = ({item, open, handleClose}) => {
    const {resume: onClickResume, isLoading, isExceededOpen, closeExceeded} =
        useDomainMonitorResume({item, handleClose});

    return (
        <>
            <ConfirmModal
                variant="resume"
                open={open}
                handleClose={handleClose}
                header={t`Возобновление монитора домена`}
                title={
                    <Trans
                        id="modal.domainMonitor.resume.title"
                        message="Вы уверены, что хотите возобновить монитор домена"
                    />
                }
                name={item.domain_human_readable}
                confirmText={t`Возобновить`}
                onConfirm={onClickResume}
                isLoading={isLoading}
            />
            <ExceededModal
                isOpen={isExceededOpen}
                handleClose={closeExceeded}
                type="domain_monitors"
            />
        </>
    );
};

export default DomainMonitorResumeModal;
